import React from "react";
import { Link } from "react-router-dom";

const ABOUT_IMG = "https://images.unsplash.com/photo-1573165706511-3ffde6ef1fe3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwzfHxkaXZlcnNlJTIwY29ycG9yYXRlJTIwcHJvZmVzc2lvbmFsc3xlbnwwfHx8fDE3ODQwNDk4NDB8MA&ixlib=rb-4.1.0&q=85";

export default function AboutPage() {
  return (
    <div className="section container-ax">
      <div className="eyebrow mb-2">About Recruvo</div>
      <h1 className="font-display text-4xl md:text-5xl font-bold text-navy max-w-3xl">
        We're recruiters who actually pick up the phone.
      </h1>
      <p className="mt-6 text-slate-600 max-w-2xl leading-relaxed">
        Recruvo Group is a modern staffing agency built on a simple idea: hourly and frontline workers deserve the same care that six-figure roles get. We invest in every candidate relationship, screen carefully, and stand behind every placement with a 90-day guarantee.
      </p>
      <img src={ABOUT_IMG} className="mt-10 rounded-2xl w-full max-h-[440px] object-cover" alt="Recruvo team" />
      <div className="mt-12 grid md:grid-cols-3 gap-6">
        <div><div className="font-display text-4xl font-bold text-navy">2019</div><div className="text-sm text-slate-500 mt-1">Founded in Orlando, FL</div></div>
        <div><div className="font-display text-4xl font-bold text-navy">10+</div><div className="text-sm text-slate-500 mt-1">Specialty industries served</div></div>
        <div><div className="font-display text-4xl font-bold text-navy">1,200+</div><div className="text-sm text-slate-500 mt-1">Successful placements</div></div>
      </div>
      <div className="mt-14">
        <Link to="/register" className="btn-gold">Join Recruvo</Link>
      </div>
    </div>
  );
}
